import React, { useState, useEffect } from "react";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import { useNavigate } from "react-router-dom";
import Table from "../../components/Table";
import Checkbox from "../../components/Checkbox";
import PopUp from "../../components/PopUp";
import Input from "../../components/Input";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import { ToolCase, Trash2, Printer, Upload } from "lucide-react";
import QRCodeGenerator from '../../components/QRCodeGenerator.jsx';
import * as XLSX from 'xlsx';
import Loader from '../../components/Loader.jsx';

const RowPC = ({ data, onCheckboxChange }) => {
    return (
        <div className="flex flex-row">
            <div onClick={(e) => e.stopPropagation()} className="flex items-center justify-center">
                <Checkbox
                    checked={data.checked}
                    onChange={() => onCheckboxChange(data.value.CodiceUnivoco)}
                    size={18}
                />
            </div>
            <div className="grid grid-cols-2 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.CodiceUnivoco}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DataCreazione}
                </div>
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
}

const Codici = () => {
    const headers = [
        { label: "Codice", key: "CodiceUnivoco" },
        { label: "Data Creazione", key: "DataCreazione" }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [isAddVisible, setIsAddVisible] = useState(false);
    const [isActionsVisible, setIsActionsVisible] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [quantita, setQuantita] = useState(0);
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        try {

            await loadNav();

            const r1 = await fetch("/getQRCodeByUser", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ ID: infoUtente.ID })
            });

            const rd1 = await r1.json();

            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { navigate("/manager/dash") }, needConfirm: false });
                setShowAlert(true);
            } else {
                setDataTable(rd1.map((d) => ({ value: d, checked: false })));
            };

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dei codici, riprovare più tardi", onClose: () => { navigate("/manager/dash") }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleStampa = async () => {
        const selectedElements = dataTable.filter((d) => d.checked).map((d) => d.value["CodiceUnivoco"]);
        if (selectedElements.length === 0) {
            setAlertInfo({ type: "info", text: "Selezionare almeno un elemento", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        // Genera tutti i QR code prima di aprire la finestra
        const qrCodes = [];
        for (const codice of selectedElements) {
            try {
                const qrUrl = await generaQrCode(codice);
                qrCodes.push({ codice, qrUrl });
            } catch (error) {
                console.error(`Errore nella generazione del QR code per ${codice}:`, error);
                qrCodes.push({ codice, qrUrl: null });
            }
        }

        // Crea la finestra di stampa
        const printWindow = window.open("", "_blank", "width=900,height=700");

        // CSS per il layout con 4 per riga
        const css = `
            <style>
                @media print {
                    @page {
                        margin: 0.5cm;
                        size: A4 portrait;
                    }
                    
                    body {
                        margin: 0;
                        padding: 0;
                        font-family: Arial, sans-serif;
                    }
                    
                    .qr-container {
                        page-break-inside: avoid;
                    }
                    
                    .qr-row {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    
                    .qr-item {
                        page-break-inside: avoid;
                    }
                }
                
                body {
                    margin: 0;
                    padding: 15px;
                    font-family: Arial, sans-serif;
                    max-width: 210mm; /* Larghezza A4 */
                    margin: 0 auto;
                }
                
                .qr-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr); /* 4 colonne per riga */
                    gap: 15px;
                    width: 100%;
                }
                
                .qr-item {
                    border: 3px solid #000;
                    border-radius: 15px;
                    padding-top: 12px;
                    padding-bottom: 12px;
                    padding-left: 6px;
                    padding-right: 6px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 200px;
                    box-sizing: border-box;
                    background-color: white;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    break-inside: avoid;
                }
                
                .qr-image-container {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    min-height: 120px;
                    margin-bottom: 8px;
                }
                
                .qr-image {
                    max-width: 100%;
                    max-height: 120px;
                    width: auto;
                    height: auto;
                    display: block;
                }
                
                .qr-code-text {
                    font-size: 12px;
                    font-weight: bold;
                    text-align: center;
                    word-break: break-all;
                    background-color: #f5f5f5;
                    border-radius: 5px;
                    width: 100%;
                    box-sizing: border-box;
                    margin-top: auto;
                    border: 1px solid #ddd;
                    font-family: 'Courier New', monospace;
                }
                
                .no-qr {
                    color: #ff0000;
                    font-size: 11px;
                    text-align: center;
                    font-weight: bold;
                    padding: 10px;
                }
                
                /* Per gestire meglio la stampa su più pagine */
                @media print {
                    .qr-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 12px;
                    }
                    
                    .qr-item {
                        min-height: 180px;
                        border: 2px solid #000;
                    }
                    
                    .qr-code-text {
                        font-size: 10px;
                        padding: 4px;
                    }
                }
                
                /* Responsive per schermi piccoli */
                @media screen and (max-width: 1000px) {
                    .qr-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 10px;
                    }
                }
            </style>
        `;

        // Dividi i QR codes in gruppi se necessario per la stampa
        const qrItems = qrCodes.map((item) => {
            return `
                <div class="qr-item">
                    <div class="qr-image-container">
                        ${item.qrUrl
                        ? `<img src="${item.qrUrl}" alt="QR Code per ${item.codice}" class="qr-image" />`
                        : `<div class="no-qr">QR non disponibile</div>`
                    }
                    </div>
                    <div class="qr-code-text">${item.codice}</div>
                </div>
            `;
        }).join('');

        printWindow.document.write(`
            <html>
                <head>
                    <title>Stampa QR Code - ${qrCodes.length} elementi</title>
                    ${css}
                </head>
                <body>
                    <div class="qr-grid">
                        ${qrItems}
                    </div>
                    <script>
                        // Attendi il caricamento di tutte le immagini
                        let images = document.getElementsByTagName('img');
                        let imagesLoaded = 0;
                        const totalImages = images.length;
                        
                        function checkAllImagesLoaded() {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                printAfterDelay();
                            }
                        }
                        
                        function printAfterDelay() {
                            setTimeout(() => {
                                window.print();
                                // Chiudi la finestra dopo la stampa
                                window.onafterprint = function() {
                                    window.close();
                                };
                            }, 500);
                        }
                        
                        // Se non ci sono immagini, stampa subito
                        if (totalImages === 0) {
                            printAfterDelay();
                        } else {
                            // Controlla il caricamento di ogni immagine
                            for (let i = 0; i < images.length; i++) {
                                if (images[i].complete) {
                                    checkAllImagesLoaded();
                                } else {
                                    images[i].onload = checkAllImagesLoaded;
                                    images[i].onerror = checkAllImagesLoaded;
                                }
                            }
                        }
                    </script>
                </body>
            </html>
        `);

        printWindow.document.close();
    };

    const handleElimina = async () => {
        const selectedElements = dataTable.filter((d) => d.checked).map((d) => d.value["CodiceUnivoco"]);
        if (selectedElements.length === 0) {
            setAlertInfo({ type: "info", text: "Selezionare almeno un elemento", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        const pass = async () => {
            setIsLoading(true);

            try {
                const r = await fetch("/eliminaQrCodes", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ QRCode: selectedElements })
                });

                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    window.location.reload();
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nell'eliminazione dei codici, riprovare più tardi", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }

            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare i codici selezionati?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const handleExport = () => {
        const selectedElements = dataTable.filter((d) => d.checked).map(d => ({ Codice: d.value["CodiceUnivoco"], DataCreazione: d.value["DataCreazione"] }));
        if (selectedElements.length === 0) {
            setAlertInfo({ type: "info", text: "Selezionare almeno un elemento", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(selectedElements);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Export.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const generaQrCode = async (id) => {
        return await QRCodeGenerator.generateQRCode(id);
    };

    const handleConferma = async () => {
        if (quantita <= 0) {
            setAlertInfo({ type: "warning", text: "Inserire una quantità valida", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }

        setIsLoading(true);
        let codici = [];

        for (let i = 0; i < quantita; i++) {
            let codice = await generateUniqueID();
            codici.push(codice);
        }

        try {
            const response = await fetch("/addQrCodes", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ QRCode: codici, ID: infoUtente.ID })
            });

            if (response.status === 500) {
                const rd = await response.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'aggiunta dei codici, riprovare più tardi", onClose: () => { setShowAlert(false) }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const generateUniqueID = async () => {
        let tempID = `${Date.now()}-${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
        return tempID;
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"CODICI QR"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <Table
                    headers={headers}
                    keyForPreview={["CodiceUnivoco"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    classes="mt-2"
                    needCheckbox={true}
                    keyForCheck="CodiceUnivoco"
                    renderButtonForCheckbox={() =>
                        <Button type="hollow" onClick={() => setIsActionsVisible(true)}>
                            AZIONI <ToolCase size={16} strokeWidth={2} className="inline-block ml-1" />
                        </Button>
                    }
                    needAdd={true}
                    addAction={() => setIsAddVisible(true)}

                />
                <PopUp title={"Aggiungi codici"}
                    isVisible={isAddVisible}
                    setIsVisible={setIsAddVisible}
                    needConfirm={true}
                    confirmAction={handleConferma}
                    cancelAction={() => setIsAddVisible(false)}
                >
                    <div className="flex flex-col items-center">
                        <Input
                            label="Quantità *"
                            value={quantita}
                            setValue={setQuantita}
                            type="number"
                            classes="w-[80%] md:w-[70%] mt-2"
                            disabled={false}
                            error={false}
                        />
                    </div>
                </PopUp>
                <PopUp title={"Azioni disponibili"}
                    isVisible={isActionsVisible}
                    setIsVisible={setIsActionsVisible}
                    needConfirm={false}
                >
                    <>
                        <div className="grid grid-cols-2 gap-2 mt-2">
                            <Button type="hollow" onClick={handleElimina}>
                                ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                            <Button type="hollow" onClick={handleStampa}>
                                STAMPA <Printer size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </div>
                        <div className="flex items-center justify-center mt-2">
                            <Button type="hollow" classes="w-[50%]" onClick={handleExport}>
                                EXPORT <Upload size={16} strokeWidth={2} className="inline-block ml-1" />
                            </Button>
                        </div>
                    </>
                </PopUp>
            </div>
        </div>
    )
};
export default Codici;